import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-admin-surface">
      <div className="text-center space-y-4">
        <Logo variant="wordmark" className="text-4xl" />
        <p className="text-sm text-muted-foreground">That page wasn't found.</p>
        <Link to="/admin" className="text-gold hover:underline">Back to dashboard</Link>
      </div>
    </div>
  );
}
